<template>
  <div class="name-content" @keyup.stop>
    <div class="title">录音名称</div>
    <div class="sub-title">输入录音名称，有助于你方便的管理录音。</div>
    <div class="input">
      <input type="text"
        :placeholder="input.placeholder"
        v-model="input.value"
        @input="validate()"
        maxlength="12"
      >
      <div class="input__tip">
        {{input.value.length}}/{{input.limit}}
      </div>
    </div>
    <div class="name-content__tip" v-show="isShowTip">
      {{input.tip}}
    </div>

    <div class="add-to" v-if="false">
      <span>将录音添加至：</span>
      <div v-for="({ text, active, place }, i) in addTo" :key="i" style="padding-left: 64px;">
        <div class="radio" @click="selectAddTo({ place })">
          <div class="radio__shape" :class="{'is-active': active}"></div>
          <div class="radio__label">{{text}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'nameContent',
  data () {
    return {
      input: {
        placeholder: '请输入录音名称',
        value: '',
        maxlength: 12,
        limit: 12,
        validate: function () {
          return this.value.length <= this.limit
        },
        tip: `请将名称限制在12字以内`
      },
      isShowTip: false,
      addTo: [
        {
          text: '当前页面',
          active: true,
          place: 'scene'
        },
        {
          text: '整个视频',
          active: false,
          place: 'global'
        }
      ]
    }
  },
  computed: {
    addedToPlace () {
      return (this.addTo.filter(item => item.active) || [])[0] || {}
    }
  },
  created () {
    this.$bus.on('nameContent.clearInput', () => {
      this.clearInput();
      this.validate();
    });
    this.$bus.on('nameContent.setInput', (val) => {
      if (val && val.length > 12) {
        val = val.slice(0, 12)
      }
      this.input.value = val
    });
  },
  methods: {
    clearInput () {
      this.input.value = '';
    },
    validate () {
      let pass = this.input.validate();
      this.isShowTip = !pass;
      this.$bus.emit('nameContent.validate', pass);
    },
    selectAddTo ({
      place
    } = {}) {
      this.addTo.map((item) => {
        this.$set(item, 'active', item.place === place);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../style/colors";
.input {
  position: relative;
  width: 410px;
  height: 40px;
  margin: 48px auto;
  background-color: $c9;
  border-radius: 4px;

  >input {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    background-color: transparent;
    padding: 0 1em;
    line-height: 40px;
    margin: 0;
    border: none;
  }

  &__tip {
    position: absolute;
    right: 1em;
    top: 50%;
    transform: translatey(-50%);
    opacity: 0.8;
  }
}

.name-content {
  position: relative;
  &__tip {
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translate(-50%, 120%);
    color: red;
  }
}

.add-to {
  display: flex;
  justify-content: center;
  align-items: center;
}

.radio {
  display: inline-block;
  display: flex;
  align-items: center;
  cursor: pointer;

  &__shape {
    // display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    width: 16px;
    height: 16px;
    border: 2px solid $c2;
    border-radius: 16px;

    &.is-active {
      box-shadow: 0 0 0 2px $c0 inset;
      background-color: $c2;
    }
  }
  &__label {
    display: flex;
    margin-left: 1.2em;
  }
  &__tip {
    position: absolute;
    bottom: 0;
    left: 0;
    transform: translatey(150%);
    color: $c2;
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/generateVoice/nameContent.vue